import { useState } from 'react'
import YesNoMessageModal from '../Components/Components/Modals/YesNoMessageModal'

/**
 * DK : Hook do potwierdzania usuwania modalem tak/nie.
 * requestDelete(message, onConfirm) - otwiera modal; onConfirm wywoła się dopiero po kliknięciu TAK.
 * confirmModal - element do wyrenderowania w komponencie.
 */
const useConfirmDelete = () => {
    const [state, setState] = useState({ show: false, message: '', onConfirm: null })

    const requestDelete = (message, onConfirm) => {
        setState({ show: true, message, onConfirm })
    }

    const handleResponse = (confirmed) => {
        const action = state.onConfirm
        setState({ show: false, message: '', onConfirm: null })
        if (confirmed === true && action) {
            action()
        }
    }

    const confirmModal = (
        <YesNoMessageModal
            show={state.show}
            onHide={handleResponse}
            title='Potwierdzenie usunięcia'
            message={state.message}
        />
    )

    return { requestDelete, confirmModal }
}

export default useConfirmDelete
